import * as yup from "yup";

const CityLocationSchema = yup.object().shape({
  name: yup.string().required("Please enter location name "),
});

export default CityLocationSchema;
